
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-stader",
      function () {
        return require("private-next-pages/about-stader.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-stader"])
      });
    }
  